export enum ReservationChannel {
  BIRDNEST = 'birdnest',
  AIRBNB = 'airbnb',
  BOOKING = 'booking',
  EXPEDIA = 'expedia',
  VRBO = 'vrbo'
}
